<!--
 * @Descripttion: 
 * @version: 站点名称/编码远程模糊查询组件
 * @Author: dengyao
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: hongye
 * @LastEditTime: 2024-12-24 16:30:23
-->
<template>
  <Select v-model:value="state.value" show-search :placeholder="$lang('请输入站点名称/编号查询')" style="width: 100%"
    :filter-option="false" :not-found-content="state.fetching ? undefined : null" :options="state.data"
    @search="fetchUser" @change="changeCode">
    <template v-if="state.fetching" #notFoundContent>
      <spin size="small" />
    </template>
  </Select>
</template>
<script lang="ts" setup>
import { reactive, toRef, watch } from 'vue'
import { Select, Spin } from 'ant-design-vue'
import { debounce } from 'lodash-es'
import { siteService } from '@/service/api'
interface Props {
  searchParam?: any
  item?: any
  stationType?: any
  reqUrl?: string
  params?: any
  optionData?: Array<never>
}
const props = defineProps<Props>()

const state = reactive({
  data: [],
  value: '',
  fetching: false
})
const fetchUser = debounce((value) => {
  if (!value) return
  if (props.reqUrl && value.length < 2) return
  state.data = []
  state.fetching = true
  siteService[props.reqUrl ? props.reqUrl : 'dimStation']({
    param: value,
    ...props.params,
    stationType: props.stationType
  }).then((res: any) => {
    state.fetching = false
    if (res.code === 1) {
      state.data = res.data.map((_: any) => {
        return {
          label: `${_.value} | ${_.key}`,
          value: _.key
        }
      })
    }
  })
}, 300)

const changeCode = (value: any) => {
  props.searchParam[props.item.prop] = value
}

watch(toRef(state.value), () => {
  state.data = []
})
watch(() => props.optionData, (data) => {
  state.data = data || []
})
</script>
